import React, { useRef, useState, useEffect } from 'react'
import { motion, useScroll, useTransform, useSpring } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import "../css/latest-release.css"
import { client } from '../client'
import { Link, useNavigate } from 'react-router-dom'
import latestReleaseText from "../assets/latestrelease.svg"
import merch from "../assets/pinball2000.jpg"
import stay800 from '../assets/stay800.jpg'
import covers2000 from '../assets/covers2000.jpg'
import allMusic from '../assets/allmusic.png'
import smiley from '../assets/Smiley.png'
import repeat from '../assets/repeat.png'

const LatestSection = ({ smart, latestImage, setOverlay, setIsRevealed }) => {

    const { ref: laundryTrigger, inView: laundry } = useInView()
    const { ref: trigger1, inView: text1 } = useInView()
    const { ref: trigger2, inView: merchText } = useInView()
    const { ref: trigger3, inView: merchTextActive } = useInView()
    const targetRef = useRef()
    const [ latest2, setLatest2 ] = useState()
    const [ latest3, setLatest3 ] = useState()
    const { ref, inView } = useInView();

    const navigate = useNavigate()

    useEffect(() => {
    setIsRevealed(inView);
  }, [inView]);

    const overlayTrigger = async () => {
        setOverlay(true)
          setTimeout(() => {
            navigate("/music")
            setOverlay(false)
          }, 1000)
     } 

    const { scrollYProgress } = useScroll({
        target: targetRef,
        offset: ["start end", "end start"]
})

const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 20,
    mass: 0.2
  });

const y = useTransform(smoothProgress, [0, 1], [-200, 200])
const rotation = useTransform(smoothProgress, [0, 1], [-90, 90])


  return (
    <>
    <div ref={ targetRef } className='latest-container'>
      <div ref={ref} style={{ height: '100%', width: '1px', position: 'absolute', top: 0, left: 0 }}></div>
      <motion.div className='sticker1' style={{ position: 'absolute', top: '10%', left: '10%', width: 'clamp(125px, 20vw, 250px)', y }}>
        <motion.img src={ smiley } style={{ height: '100%', width: '100%', rotate: rotation }} />
      </motion.div>
      <motion.div className='sticker2' style={{ position: 'absolute', bottom: '7%', right: '10%', width: 'clamp(125px, 20vw, 250px)', y }}>
        <motion.img src={ repeat } style={{ height: '100%', width: '100%', rotate: rotation }} />
      </motion.div>
      
      <div className='latest-square-marquee1' style={{ width: '450px', height: '450px', position: 'relative', zIndex: 5 }}>
        
        <a href={ smart } target='_blank' style={{ cursor: 'pointer' }}>
        <div style={{ position: 'absolute', width: '1', height: '1', right: '-78px', bottom: '2px',  transformOrigin: 'left center', rotate: '90deg', }}>
          <div style={{ position: 'absolute', fontSize: '2.5rem', color: '#fff000', width: '502px', height: '64px', filter: 'blur(0.5px)', overflow: 'hidden', right: '0px', bottom: '-78px' }}>
            <motion.div style={{ width: '1000px' }} animate={{ x: '-345px', transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST</motion.div>
          </div>
        </div>

        <div style={{ position: 'absolute', fontSize: '2.5rem', filter: 'blur(0.5px)', color: '#fff000', width: '502px', height: '64px', overflow: 'hidden', left: '-52px', top: '-64px' }}>
          <motion.div style={{ width: '1000px' }} animate={{ x: '-345px', transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST</motion.div>
        </div>

        <div style={{ position: 'absolute', fontSize: '2.5rem', filter: 'blur(0.5px)', color: '#fff000', width: '502px', height: '64px', overflow: 'hidden', right: '-52px', bottom: '-78px' }}>
          <motion.div style={{ width: '1000px' }} animate={{ x: '-345px', transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST</motion.div>
        </div>

        <div style={{ position: 'absolute', fontSize: '2.5rem', filter: 'blur(0.5px)', color: '#fff000', width: '502px', transformOrigin: 'left center', rotate: '-90deg', height: '64px', overflow: 'hidden', right: '-30px', bottom: '-84px' }}>
          <motion.div style={{ width: '1400px', rotate: '-180deg', marginTop: '-8px' }} animate={{ x: [ -900, -555 ], transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST RELEASE</motion.div>
        </div>
        <img src={ latestImage } style={{ width: '100%', height: '100%', position: 'relative' }} />
        </a>

        <div style={{ width: '100%', top: '7rem', position: 'relative', justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: '1.5rem' }}>
          <Link to='/music'>
            <motion.div whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}>
              <img src={ allMusic } style={{ width: '100%' }} />
            </motion.div>
          </Link>
        </div>
      </div>
      

            

      <div className='latest-square-marquee2' style={{ width: '180px', height: '180px', position: 'absolute', zIndex: 5, backgroundColor: 'red', display: 'flex' }}>
      <a href={ smart } target='_blank' style={{ width: '180px', height: '180px', position: 'absolute', zIndex: 6 }}>

        <div style={{ position: 'absolute', width: '1', height: '1', right: '-14px', top: '-20px',  transformOrigin: 'left center', rotate: '-90deg', }}>
        <div style={{ position: 'absolute', fontSize: '1rem', color: '#fff000', width: '200px', height: '26px', overflow: 'hidden', right: '0px', bottom: '-16px' }}>
          <motion.div style={{ width: '1000px', filter: 'blur(0.5px)' }} animate={{ x: '-140px', transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST</motion.div>
        </div>
        </div>

        <div style={{ position: 'absolute', fontSize: '1rem', color: '#fff000', width: '200px', height: '26px', overflow: 'hidden', left: '-21px', top: '-24px' }}>
          <motion.div style={{ width: '1000px', filter: 'blur(0.5px)' }} animate={{ x: '-140px', transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST</motion.div>
        </div>

        <div style={{ position: 'absolute', fontSize: '1rem', color: '#fff000', width: '200px', height: '26px', overflow: 'hidden', right: '-20px', bottom: '-32px' }}>
          <motion.div style={{ width: '1000px', filter: 'blur(0.5px)' }} animate={{ x: '-140px', transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST</motion.div>
        </div>

        <div style={{ position: 'absolute', fontSize: '1rem', color: '#fff000', width: '200px', transformOrigin: 'left center', rotate: '-90deg', height: '26px', overflow: 'hidden', right: '-8px', bottom: '-34px' }}>
          <motion.div style={{ width: '1400px', rotate: '-180deg', marginTop: '-0px', filter: 'blur(0.5px)' }} animate={{ x: [ -1200, -1060 ], transition: { duration: 5, repeat: Infinity, ease: 'linear' } }}>LATEST RELEASE LATEST RELEASE LATEST RELEASE</motion.div>
        </div>
        <img src={ latestImage } style={{ width: '100%', height: '100%', position: 'absolute' }} />
      </a>
      <div style={{ width: '100%', position: 'relative', bottom: '-10rem', justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: '1.5rem' }}>
          <Link to='/music'>
            <motion.div whileHover={{ scale: 1.1, transition: { duration: 0.3 } }}>
              <motion.img src={ allMusic } style={{ width: '100%' }} />
            </motion.div>
          </Link>
        </div>
        </div>
      

    </div>
    </>

    // <div ref={ laundryTrigger } style={{ position: "relative", height: "200vh", width: "100vw", zIndex: 100 }}>
    //     <motion.div className="latest-container" ref={ targetRef }>
    //         <div style={{ height: "30vh", position: "relative" }}></div>
    //         <div ref={ trigger1 } style={{ height: "100vh", position: "relative" }}></div>
    //         <motion.div style={{ display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none", opacity: opacity1 }} className="latest-bg">
    //             <img src={latestReleaseText} style={{ height: "160vh", marginLeft: "0" }} />
    //         </motion.div>
    //     <motion.div style={{ position: "fixed", height: "100vh", width: "100vw", top: 0, overflow: "hidden", y: positionY, zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
    //         <motion.div className="latest-image-container" style={{ position: "relative", zIndex: 100 }}>
    //             <div style={{ overflow: "hidden" }}>
    //             <a href={ smart } target="_blank">
    //             <motion.div animate={ latest2 ? {opacity: 1} : {opacity: 0} } onMouseEnter={() => {setLatest2(true)}} onMouseLeave={() => {setLatest2(false)}}  style={{ position: "absolute", cursor: "pointer", width: "100%", height: "100%", backgroundColor: "#09090999", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
    //             <motion.div animate={ latest2 ? {rotate: "45deg"} : {rotate: 0} } transition={{ ease: [0.5, 0.7, 0.05, 0.9], duration: 0.5 }}><svg width="50" height="50">
    //                     <line x1="48" y1="2" x2="2" y2="48" stroke="white" />
    //                     <line x1="48" y1="2" x2="48" y2="48" stroke="white" />
    //                     <line x1="2" y1="2" x2="48" y2="2" stroke="white" />
    //                 </svg>
    //             </motion.div>
    //             </motion.div></a>
    //             { laundry &&
    //             <motion.img animate={ latest2 ? { scale: 1.05 } : { scale: 1 } } transition={{ duration: 0.5, ease: "easeIn" }} dragConstraints={{ x: 0 }} src={ latestImage } style={{ objectFit: "cover", height: "100%", width: "100%", zIndex: 900, position: "relative" }} />
    //             }
    //             </div>
    //             <motion.div onMouseEnter={() => {setLatest2(true)}}  onMouseLeave={() => {setLatest2(false)}} animate={ text1 ? { opacity: 1 } : { opacity: 0 } } className="latest-more" style={{ top: "-50px", cursor: "pointer", fontSize: "clamp(0.8rem, 1vw, 1.2rem)" }}>
    //                 <motion.a href={ smart } target="_blank" animate={ latest2 ? { opacity: 0.7 } : { opacity: 1 }}>Latest release</motion.a>
    //             </motion.div>
    //             <motion.a href="#" onMouseEnter={() => {setLatest3(true)}}  onMouseLeave={() => {setLatest3(false)}} animate={ latest3 ? { opacity: 0.7 } : { opacity: 1 }} onClick={overlayTrigger} className="latest-more" style={{ marginTop: "10px", cursor: "pointer", fontSize: "clamp(0.8rem, 1vw, 1.2rem)" }}>Listen to more music here
    //             </motion.a>
    //         </motion.div>
    //     </motion.div>
    //     </motion.div>
        
    //     <motion.div style={{ position: "fixed", y, width:"100vw", bottom: 0, zIndex: 500, overflow: "hidden", backgroundColor: "red" }} >
    //         <motion.div style={{ height: "100vh", width:"100vw", bottom: 0, alignItems: "start", display: "flex" }}>
    //             <div className="merch-overlay" style={{ background: "linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%)", zIndex: 550, width: "100vw", height: "100vh", position: "fixed", top: 0 }}></div>
    //             <img src={ merch } width="100%" height="100%" style={{ objectFit: "cover", objectPosition: "top", top: 0, position: "absolute" }} />
    //         </motion.div>
    //     </motion.div>
    //     { merchTextActive &&
    //     <>
    //     <motion.div className="merch1" style={{ filter: 'blur(0.5px)', fontFamily: '"Inter", sans-serif' }} initial={{ opacity: 0 }} animate={ merchText ? { opacity: 1 } : { opacity: 0 }}><h5>MERCHANDISE</h5><h1 className="merch1-2" style={{ letterSpacing: "-0.03em", lineHeight: '2.8rem', fontSize: "clamp(3rem, 5vw, 3.2rem)", position: "relative", top: -20, left: -2, color: '#fff000' }}>
    //         <motion.span animate={ merchText ? { opacity: 1, transition: { delay: 0.1, duration: 1 } } : { opacity: 0 }}>SHOP</motion.span><br /><motion.span animate={ merchText ? { opacity: 1, transition: { delay: 0.2, duration: 1 } } : { opacity: 0 }}>GALANTIS</motion.span></h1>
    //     </motion.div>
    //     <motion.div className="merch2" initial={{ opacity: 0 }} animate={ merchText ? { opacity: 1, transition: { delay: 0.3, duration: 1 } } : { opacity: 0 }}><h5 style={{ marginLeft: '-2px' }}>INTERNATIONAL STORES</h5><h1 className="merch2-2" style={{ letterSpacing: "-0.03em", fontFamily: '"Inter", sans-serif', filter:'blur(0.5px)', lineHeight: '2.8rem', fontSize: "clamp(3rem, 5vw, 3.2rem)", cursor: "pointer", position: "relative", top: -20, left: -4 }}>
    //         <motion.a style={{ textDecoration: "none", color: '#fff000' }} whileHover={{ color: "#fff" }}  href='https://galantis.merchtable.com/' target="_blank" animate={ merchText ? { opacity: 1, transition: { delay: 0.4, duration: 1 } } : { opacity: 0 }}>US /</motion.a> <motion.a style={{ textDecoration: "none" }} whileHover={{ color: "#fff" }} href='https://shop.mu-mo.net/gjos/' target="_blank" animate={ merchText ? { opacity: 1, transition: { delay: 0.5, duration: 1 } } : { opacity: 0 }}>JAPAN /</motion.a><br />
    //         <motion.a style={{ textDecoration: "none", color: '#fff000' }} whileHover={{ color: "#fff" }} href='https://store.100-percent.co.uk/collections/galantis' target="_blank" animate={ merchText ? { opacity: 1, transition: { delay: 0.6, duration: 1 } } : { opacity: 0 }}>UK & EUROPE</motion.a></h1>
    //     </motion.div>
    //     </>
    //     }
    //     <div style={{ position: "relative", height: "90vh", width: "20vw", zIndex: 601, pointerEvents: "none" }}></div>
    //     <div ref={ trigger3 } style={{ position: "relative", height: "10vh", width: "20vw", zIndex: 601, pointerEvents: "none" }}></div>
    //     <div ref={ trigger2 } style={{ position: "relative", height: "5vh", width: "20vw", zIndex: 601, pointerEvents: "none" }}></div>
    // </div>
  )
}

export default LatestSection